/* @flow */

import React from 'react';
import { Card, Icon, Message } from 'semantic-ui-react';
import ResourceVideo from 'shared/components/ResourceVideo';

type Props = {
  content: CatalogPageContent,
};

const View = ({ content }: Props) => {
  if (content.resource) {
    return (
      <Card centered>
        <ResourceVideo video={content.resource} />
        <Card.Content extra>
          <a
            href={content.resource.url.original}
            target="_blank"
            rel="noopener noreferrer"
            icon="file video outline"
            className="ui labeled fluid icon basic button"
          >
            <Icon name="file video outline" />
            Télécharger
          </a>
        </Card.Content>
      </Card>
    );
  }

  return <Message icon="info" header="Aucun PDF associé à cette page" />;
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/video/View.js